import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: "I've never coached before. Is this too advanced for me?",
  a: 'It is built for exactly that. Volume 1 starts at "never held a racket", every session has a short cue script telling you what to say, and two bonuses cover the rules and the key cue for every shot. Start at Session 1 and follow the ladder.'
}, {
  q: 'What levels does it cover?',
  a: 'Beginner to intermediate, for juniors and adults. Every drill comes with a 3-Level Dial — beginner, developing and advanced versions — so you can pitch the same session at the group in front of you.'
}, {
  q: 'How do I handle a mixed-ability group?',
  a: 'That is what the 3-Level Dial is for. Each volume also includes a mixed-ability clinic session, station circuits for large groups, and a worked example of the same session run at three levels.'
}, {
  q: 'I already have my own drills. Do I need this?',
  a: 'Keep them. What the pack adds is the order: which skill comes next, which game applies it, and how it all builds across a season. The drill cards and blank court sheets make it easy to slot your own drills in.'
}, {
  q: 'Is it printable or digital only?',
  a: 'Digital PDFs, laid out for printing. Most coaches print the session sheets and drill cards and keep them on a clipboard at the court.'
}, {
  q: 'Is it safe for young players?',
  a: 'Every session starts with a warm-up game, and movement work includes safe lunging technique. It does not replace your coaching qualification, first-aid training or your venue and club rules — you check that each activity suits your players and setting before you run it.'
}, {
  q: 'How do I get it?',
  a: 'Instant download after checkout, plus an email with your files. Lifetime access to what you bought.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq-heading" className="w-full bg-white text-ink" data-id="element-117" data-mp="1uguntzo6whs5">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-118" data-mp="1uixmt97bll90">
        <div className="text-center" data-id="element-119" data-mp="1ppckj4yp2540">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-court" data-id="element-120" data-mp="1pob8oy9utel8">
            Before you buy
          </p>
          <h2 id="faq-heading" className="mt-3 font-display font-bold text-ink text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-121" data-mp="1fs84znzct7w6">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-8 grid gap-2.5" data-id="element-122" data-mp="28hx9wcf6ps32">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-xl border border-line bg-white" data-id="element-123" data-mp="1zfxsvk466o04" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left text-[15px] font-semibold text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-court" data-id="element-124" data-mp="s2dwfim2i5hq">
                  {faq.q}
                  {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-court" aria-hidden="true" data-id="element-125" data-mp="38ok81gh8jg15" /> : <PlusIcon className="h-5 w-5 flex-none text-court" aria-hidden="true" data-id="element-126" data-mp="3dgape6elb422" />}
                </button>
                {isOpen && <p className="px-4 pb-4 text-sm text-ink-soft" data-id="element-127" data-mp="3igyges2tjkwa">{faq.a}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}